import { z } from "zod";
//#region src/api/orpc/extraPackageBoost/schemas.ts
const boostStatusSchema = z.enum([
	"available",
	"locked",
	"redeemed",
	"expired",
	"revoked"
]);
const boostSortFieldSchema = z.enum(["createdAt", "boostRatePercentage"]);
const extraPackageBoostSchema = z.object({
	id: z.bigint(),
	templateId: z.bigint(),
	userId: z.bigint(),
	code: z.string(),
	boostRatePercentage: z.number().int().min(0).max(100),
	grantSourceType: z.string(),
	grantSourceId: z.string().nullable(),
	issuedBy: z.string().nullable(),
	note: z.string().nullable(),
	status: boostStatusSchema,
	lockedAt: z.iso.datetime().nullable(),
	redeemedAt: z.iso.datetime().nullable(),
	lockedForOrderId: z.bigint().nullable(),
	availableSince: z.iso.datetime(),
	availableUntil: z.iso.datetime(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime()
});
const templateStatusSchema = z.enum([
	"active",
	"inactive",
	"archived"
]);
const extraPackageBoostTemplateSchema = z.object({
	id: z.bigint(),
	name: z.string(),
	description: z.string().nullable(),
	paymentItemIds: z.array(z.string()),
	codePrefix: z.string(),
	boostRatePercentage: z.number().int().min(0).max(100),
	userReceiveLimit: z.number().int().min(1),
	availableSince: z.iso.datetime(),
	availableUntil: z.iso.datetime(),
	status: templateStatusSchema,
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime()
});
//#endregion
export { boostSortFieldSchema, boostStatusSchema, extraPackageBoostSchema, extraPackageBoostTemplateSchema, templateStatusSchema };
